import { Link, List, ListItem } from '@mui/material';
import { useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { getCurrentTranslation } from '~/data/people';
import { useSelectedEmployeeId } from '~/hooks/employee/useSelectedEmployeeId';

import { NavigatableModule, getSF2Path, useMenuLinks } from './useMenuLinks';
import { useSxStyles } from './useStyles';

type PropsType = {
  target?: string;
  color?: string;
  routerLink?: boolean;
};

const getSF2Navigation = (sf2Path: string, enableRouter?: boolean) => {
  return enableRouter
    ? { to: getSF2Path(sf2Path), component: RouterLink }
    : { href: getSF2Path(sf2Path, true) };
};

export const LeftSideMenuLinks = (props: PropsType) => {
  const { target, color, routerLink } = props;
  const sxStyles = useSxStyles();
  const { generalMenuLinks } = useMenuLinks();
  const { selectedEmployeeId } = useSelectedEmployeeId();

  const listItems = useMemo(
    () =>
      generalMenuLinks.map((menuLink) => {
        const currentTranslation = getCurrentTranslation(menuLink.translations);
        const module = menuLink.navigation ? menuLink.navigation.module : '';
        const tab = menuLink.navigation ? menuLink.navigation.tab : '';
        const linkName = currentTranslation ? currentTranslation.name : '';

        const redirectParams = [
          `empId=${selectedEmployeeId}`,
          `area=${module}`,
          `subarea=${tab}`,
        ].join('&');

        const linking =
          module === NavigatableModule.SF2
            ? getSF2Navigation(tab, routerLink)
            : { href: `/page-ui2-redirect?${redirectParams}` };

        return (
          <ListItem key={menuLink.id}>
            <Link
              sx={sxStyles.link}
              color={color ? color : 'MenuText'}
              underline="none"
              variant="body1"
              target={target}
              {...linking}
            >
              {linkName}
            </Link>
          </ListItem>
        );
      }),
    [
      sxStyles.link,
      color,
      generalMenuLinks,
      routerLink,
      selectedEmployeeId,
      target,
    ],
  );

  return <List sx={sxStyles.list}>{listItems}</List>;
};
